import { jsx as _jsx } from "react/jsx-runtime";
const CheckIcon = ({ size = 16, className }) => {
    return (_jsx("svg", { width: size, height: size, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: className, children: _jsx("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z", fill: "currentColor" }) }));
};
export default CheckIcon;
//# sourceMappingURL=check-icon.js.map